<template>
  <b-navbar id="nav" toggleable="lg" type="dark" variant="info" fixed="top" role="main">
    <section class="container">
      <b-navbar-brand role="banner">
        <router-link to="/" aria-labelledby="brandName">
          <img src="../../src/assets/reh-logo.png" alt="REH Designs Logo" id="reh-logo" aria-hidden="true">
          <span aria-hidden="true"> REH Designs</span>
          <span id="brandName" class="sr-only">REH Designs (Home Page)</span>
        </router-link>
      </b-navbar-brand> 
      
      <b-navbar-toggle target="nav_collapse" aria-label="Toggle Navigation" />

      <b-collapse is-nav id="nav_collapse" role="navigation">
        <b-navbar-nav class="ml-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/about">About</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/project-spotlight">Project Spotlight</router-link> 
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/work">Work Examples</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/contact">Contact</router-link>
          </li>
        </b-navbar-nav>
      </b-collapse>
    </section>
  </b-navbar>
</template>

<script>
export default {
  name: 'navigation',
  props: {
    msg: String
  }
}
</script>

<style lang="less">
@import '~../less/variables.less';
@import '~../less/global.less';

#nav{
  background: rgba(6, 41, 11, .95) !important;
  font-family: 'Josefin Slab', serif;
  padding: 2px 1rem;

  a {
    text-decoration: none;
  }

  .navbar-brand{
    #reh-logo{
      width: 60px;
      height: 100%;
    }

    a{
      color: white;
      font-size: 21px;
      font-weight: 600;

      &:hover{
        text-decoration: none;
      }
    }
  }
}
</style>